@import "../../packages/shared/scss";

:host {
  @include pds-text-small;
  display: flex;
}
